<script setup>
import {onMounted, defineProps} from "vue";
import {useStore} from "@/store";

const store = useStore();

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
});

onMounted(() => {
  setTimeout(() => {
    deleteNotification();
  }, props.item.lifeTime);
});

const deleteNotification = () => {
  let index =  store.notifications.findIndex(it => it.message === props.item.message);
  store.notifications.splice(index, 1);
};
</script>

<template>
  <div
    class="notification-item"
    @click="deleteNotification"
  >
    <div class="notification-item__icon">
      <svg
        v-if="item.type === 'success'"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.4542 3.09082L16.9996 18.5608L12.3633 13.9245"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32.4252 13.5333C33.0665 13.3892 33.7075 13.7919 33.8064
           14.4417C34.3356 17.9173 33.7751 21.4827 32.1861
            24.6407C30.4184 28.1541 27.4872 30.9459 23.8918
             32.5404C20.2965 34.1348 16.2595 34.4333 12.4688 33.385C8.678 32.3367
              5.36801 30.0064 3.10277 26.7912C0.837533 23.576 -0.242802 19.6748
               0.0458436 15.7524C0.334489 11.8299 1.97426 8.12893 4.68575
                5.27997C7.39724 2.431 11.0127 0.610342 14.9161 0.128213C18.4246
                 -0.305149 21.9706 0.367025 25.0655 2.03507C25.644 2.34689
                  25.8075 3.08607 25.456 3.64138C25.1045 4.1967 24.3712 4.35716
                   23.7892 4.05196C21.1627 2.67472 18.1697 2.12442 15.2078 2.49026C11.8509
                    2.90489 8.74163 4.47066 6.40974 6.92077C4.07786 9.37088 2.66766 12.5537
                     2.41943 15.927C2.17119 19.3003 3.10028 22.6553 5.04838
                      25.4204C6.99649 28.1855 9.84308 30.1895 13.1031 31.0911C16.3632
                       31.9927 19.835 31.7359 22.927 30.3647C26.019 28.9935 28.5398 26.5926 30.0601
                        23.571C31.4014 20.905 31.8906 17.9015 31.4777 14.9647C31.3861 14.3139 31.784
                         13.6774 32.4252 13.5333Z"
          fill="white"
        />
      </svg>
      <svg
        v-if="item.type === 'error'"
        width="34"
        height="34"
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9997 31.1666C24.8237 31.1666 31.1663
           24.824 31.1663 16.9999C31.1663 9.17588 24.8237 2.83325
            16.9997 2.83325C9.17564 2.83325 2.83301 9.17588 2.83301
             16.9999C2.83301 24.824 9.17564 31.1666 16.9997 31.1666Z"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 11.3333V16.9999"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17 22.6667H17.0142"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="notification-item__message">
      {{ item.message }}
    </div>
  </div>
</template>

<style scoped lang="scss">
.notification-item {
  font-size: 22px;
  font-weight: 400;
  display: flex;
  align-items: center;
  max-width: 400px;
  padding: 20px;
  cursor: pointer;
  user-select: none;
  color: #FFFFFF;
  border-radius: 20px;
  background: #1F9AFF;
  gap: 10px;

  &__message {
    font-size: 22px;
    font-weight: 400;
    display: flex;
  }
}
</style>